<template>
  <div class="my-news-desc-div1">
    <span v-html="content" class="my-news-desc-span1"></span>
  </div>
</template>

<script>
  import {
    getNewsDesc
  } from '@/api/news.js'

  export default {
    name: "NewsDesc",
    data() {
      return {
        content: "",
      };
    },
    components: {},
    methods: {},
    created() {
      var id = this.$route.query.id;
      getNewsDesc('news/getById?id=' + id, this)
    }
  }
</script>

<style>
  .my-news-desc-div1 {
    text-align: left;
    background: white;
  }

  .my-news-desc-span1 {
    font-size: 18px;
    text-indent: 2em;
  }

  p {
    margin-block-start: 0em;
    margin-block-end: 0em;
  }

  h1 {
    margin-block-start: 0em;
  }
</style>



// WEBPACK FOOTER //
// src/components/news/NewsDesc.vue